import { Component, Link, withProps } from '@mna/react'
import Carousel from '@mna/react-ui/Carousel'
import Item from './CarouselItem'
import {checkAndGetSessionStorageValue} from "../../../features/utils";

function absoluteModulo(value, max) {
  const remain = value % max
  return Math.floor(remain >= 0 ? remain : remain + max)
}

export default class CareOptionsCarousel extends Component {

  constructor(props) {
    super(props)
    this.state = {
      value: 0, // Can be negative, or above number of slides
      index: 0 // Slide index, 0~max
    }
  } 
  componentDidMount() {
    const { state, actions } = this.props
    const container = document.getElementsByClassName('carousel-track');
    if (container && container.length > 0)
    {
      const collection = document.getElementsByClassName('carousel-card')
      const myElements = Array.from(collection);
      myElements.forEach((element) => {
        if(!element.hasAttribute('role')){
          element.setAttribute('role','group');
        }
      });
    }
  };
  render() {
    const { cards, numberOfCards, goCareOption } = this.props
    var careOptions = []
    var onChange = (value) => {
      const index = absoluteModulo(value, numberOfCards)
      const optionValue = cards[index] && cards[index].value
  
      console.log('onChange', { index, value, optionValue })
  
      this.setState({ index, value })
      if(checkAndGetSessionStorageValue("IsValidUser") === "true"){
        if (this.props.onChange) this.props.onChange({ index, ...(careOptions[index] || {}) })
       }
       else {
        if (this.props.onChange) this.props.onChange({ index, ...(cards[index] || {}) })
       }      
    }  
   
    cards.filter(card => card.alt !== "House Visit" && card.alt !=="Concierge Care").forEach(element => {
      careOptions.push(element)
      } )   
      
    return (
      <div className="my-3 care-options-carousel">
      {checkAndGetSessionStorageValue("IsValidUser") === "true" ? 
        <Carousel
          {...{
            items: careOptions.map((props, optionIndex) =>
              <Item key={`care-option-${optionIndex}`} {...props} goCareOption={goCareOption} />
            ),
            cardWidth: 320,
            cardHeight: 445,
            loop: numberOfCards > numberOfCards * 2 ,
            cardPadCount: numberOfCards > 2 ? 0 : 0, //(numberOfCards * 3),
            onChange: onChange
          }}
        /> : 
        <Carousel
          {...{
            items: cards.map((props, optionIndex) =>
              <Item key={`care-option-${optionIndex}`} {...props} goCareOption={goCareOption} />
            ),
            cardWidth: 320,
            cardHeight: 445,
            loop: numberOfCards > numberOfCards * 2 ,
            cardPadCount: numberOfCards > 2 ? 0 : 0, //(numberOfCards * 3),
            onChange: onChange
          }}
        />
}
      </div>
    )
  }
}
